<template>
<div>
    
    <section-header />


    <section class="about-section">
            <div class="auto-container">
                <div class="row clearfix">
                    <!--Column-->
                    <div class="title-column col-md-4 col-sm-12 col-xs-12">
                        <div class="inner">
                        <h2>{{ $t('view.home.section-title-a') }}</h2>
                        <div class="text">
                            <p class="justify">
                                {{ $t('view.home.text-a') }}
                            </p>
                            <p class="justify">
                                {{ $t('view.home.text-b') }}
                            </p>
                            <p class="justify">
                                {{ $t('view.home.text-c') }}
                            </p>
                        </div>
                        </div>
                        <router-link to="/contact" class="theme-btn btn-style-three">{{ $t('common.request-quote') }}</router-link>
                    </div>
                    <!--Content Column-->
                    <div class="content-column col-md-8 col-sm-12 col-xs-12">
                        <div class="inner-box">
                            <div class="row clearfix">

                                <!--Section Content-->
                                <div class="section-content col-md-6 col-sm-6 col-xs-12">
                                    <div class="inner">
                                        <img src="images/resource/bcom/home-2.jpg" alt="" />
                                        <div style="background-color:#0d70b7; padding:20px 20px; color:#ffffff;font-size:17px;font-weight:400;line-height:1.6em;">
                                            {{ $t('view.home.text-d') }}
                                            <br><br>
                                            {{ $t('view.home.text-e') }}
                                        </div>
                                        <br><br>
                                    </div>
                                </div>
                                <!--Section Content-->
                                <div class="section-content col-md-6 col-sm-6 col-xs-12">
                                    <div class="inner">
                                        <h2>{{ $t('view.home.section-title-b') }}</h2>
                                        <div class="text">
                                            <p class="justify">
                                                {{ $t('view.home.text-f') }}
                                            </p>
                                        </div>
                                        <div class="text justify">{{ $t('view.home.text-g') }}</div>
                                        <ul class="list-style-one">
                                            <li>{{ $t('view.home.list-a.item-1') }}</li>
                                            <li>{{ $t('view.home.list-a.item-2') }}</li>
                                            <li>{{ $t('view.home.list-a.item-3') }}</li>
                                            <li>{{ $t('view.home.list-a.item-4') }}</li>
                                            <li>{{ $t('view.home.list-a.item-5') }}</li>
                                            <li>{{ $t('view.home.list-a.item-6') }}</li>
                                            <li>{{ $t('view.home.list-a.item-7') }}</li>
                                            <li>{{ $t('view.home.list-a.item-8') }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="featured-section">

        </section>


        <section class="featured-section">
            <div class="auto-container">
                <div class="services-outer">
                    <div class="clearfix">

                        <!--Services Block-->
                        <div class="services-block col-md-4 col-sm-6 col-xs-12">
                            <div class="inner-box">
                                <div class="icon-box">
                                    <span class="icon flaticon-teacher"></span>
                                </div>
                                <h3>{{ $t('view.home.title-1') }}</h3>
                                <div class="text"></div>
                                <div class="overlay-box">
                                    <div class="overlay-inner">
                                        <div class="icon-box">
                                            <span class="icon flaticon-teacher"></span>
                                        </div>
                                        <div class="text">{{ $t('view.home.text-h') }}<br/></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--Services Block-->
                        <div class="services-block col-md-4 col-sm-6 col-xs-12">
                            <div class="inner-box">
                                <div class="icon-box">
                                    <span class="icon flaticon-employee"></span>
                                </div>
                                <h3>{{ $t('view.home.title-2') }}</h3>
                                <div class="text"></div>
                                <div class="overlay-box">
                                    <div class="overlay-inner">
                                        <div class="icon-box">
                                            <span class="icon flaticon-employee"></span>
                                        </div>
                                        <div class="text">{{ $t('view.home.text-i') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--Services Block-->
                        <div class="services-block col-md-4 col-sm-6 col-xs-12">
                            <div class="inner-box">
                                <div class="icon-box">
                                    <span class="icon flaticon-global-networking"></span>
                                </div>
                                <h3>{{ $t('view.home.title-3') }}</h3>
                                <div class="text"></div>
                                <div class="overlay-box">
                                    <div class="overlay-inner">
                                        <div class="icon-box">
                                            <span class="icon flaticon-global-networking"></span>
                                        </div>
                                        <div class="text">{{ $t('view.home.text-j') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>


        <section class="featured-section-two">
            <div class="auto-container">
                <div class="row clearfix">

                    <!--Featured Block Two-->
                    <div class="featured-block-two col-lg-4 col-md-6 col-sm-6 col-xs-12">
                        <div class="inner-box">
                            <div class="icon-box">
                                <span class="icon flaticon-analytics-1"></span>
                            </div>
                            <h3><router-link :to="{ name: 'services-activities', hash: '#activities-managed-in-house'}">{{ $t('view.home.title-4') }}</router-link></h3>
                            <div class="text">{{ $t('view.home.text-k') }}</div>
                        </div>
                    </div>

                    <!--Featured Block Two-->
                    <div class="featured-block-two col-lg-4 col-md-6 col-sm-6 col-xs-12">
                        <div class="inner-box">
                            <div class="icon-box">
                                <span class="icon flaticon-headphones"></span>
                            </div>
                            <h3><router-link :to="{ name: 'services-activities', hash: '#collaboration-with-our-trusted-partners'}">{{ $t('view.home.title-5') }}</router-link></h3>
                            <div class="text">{{ $t('view.home.text-l') }}</div>
                        </div>
                    </div>

                    <!--Featured Block Two-->
                    <div class="featured-block-two col-lg-4 col-md-6 col-sm-6 col-xs-12">
                        <div class="inner-box">
                            <div class="icon-box">
                                <span class="icon flaticon-business-2"></span>
                            </div>
                            <h3><router-link :to="{ name: 'services-activities', hash: '#financial-services-in-house-managed'}">{{ $t('view.home.title-6') }}</router-link></h3>
                            <div class="text">{{ $t('view.home.text-m') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <section class="featured-section-two">
        </section>
</div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue';

export default {
  name: 'Home',
  components: {
    SectionHeader
  },
  data() {
    return {
      content: ''
    };
  },
  computed: {
   currentPa() {
        return this.$router.history.current.name;
      },
  },
  mounted() {

  }
};
</script>